import React from 'react'
import styled from '@emotion/styled'

const H1 = styled.h1`
`

export default H1